export class AcceptUnknownDeclarationMapper {}

export class AcceptUnknownDeclarationErrorMapper {}
